import { useMutation } from "react-query";
import { useRef } from "react";

/** Fetches the user by it's id
 *
 * @param {userId}
 *    @userId identifies the user that we will retreive
 * @returns {mutation, data}
 *    @mutation the mutated hook to be used to retrieve messages that calls the fetch and returns.
 *    @data returns a user dictionary
 */

const getUser = async (userId) => {
  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_API}/users/${userId}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );

  if (response.status === 200) {
    const data = await response.json();
    return data;
  } else {
    throw new Error(`Server responded with status: ${response.status}`);
  }
};

export const useGetUser = () => {
  const resolveMutation = useRef(null);

  const mutation = useMutation((userId) => getUser(userId), {
    onSettled: (data, error) => {
      if (resolveMutation.current) {
        if (error) {
          resolveMutation.current.reject({ error });
        } else {
          resolveMutation.current.resolve({ data });
        }
      }
    },
  });

  const getUserWithPromise = (userId) => {
    return new Promise((resolve, reject) => {
      resolveMutation.current = { resolve, reject };
      mutation.mutate(userId);
    });
  };

  return { ...mutation, getUser: getUserWithPromise };
};